import React, { useContext } from 'react'
import CartContext from '../../Context/CartContext';
import { Link } from 'react-router-dom';
import './Cart.css'
import { MdOutlineDeleteForever, MdDeleteOutline } from 'react-icons/md'
export const Cart = () => {

  const { cart, removeItem, clear, getTotal } = useContext(CartContext)


  console.log(cart)
  return (
    <section className='cart'>
    {cart.length === 0 ? 
      <section className='cartEmpty flex flex-col justify-center items-center mb-10'>
        <h2>Aún no agregaste productos al carrito</h2>
        <Link to={'/Productos'} className='text-center text-white	text-3xl underline	'>Ver productos</Link>
      </section>
      : 
        <div className="rowsCart">
          <section className='inline-block mt-5 sm:hidden'>
        
        <table className="table w-5/6	m-auto lg:w-4/6 xl:w-4/6 2xl:w-3/6">
        <thead className='CartDetail w-5/6	m-auto'>
        <tr>
          
          <th className='p-2 text-center'>Producto</th>
          <th className='p-2 text-center'>Precio</th>
          <th className='p-2 text-center'>Unidades</th>
          <th className='p-2 text-center'>Subtotal</th>
          <th className='p-2 text-center'></th>
          </tr>
          </thead>
      {
        cart.map(products=> 
          <>

          <tbody key={products.id} className='max-h-24'>
          <tr className=" max-h-24 ">
          <td className='cellImg text-center w-1/12 2xl:w-2/12'><img src={products.pictureUrl} alt={products.title} className='imgCart object-contain'/>{products.title}</td>
          <td className='text-center	'>${products.price}</td>
          <td className='text-center	'>{products.quantity}</td>
          <td className='text-center	'>${products.price*products.quantity}</td>
          <td className='text-end	'><button onClick={(e)=>removeItem(products.id)}  ><MdOutlineDeleteForever className='btnTrash justify-self-end'/></button></td>
          </tr>
          </tbody>
          </>
      )
    } 
      </table>
      </section>
      {
        cart.map(products=> 
      <section className='hidden w-full sm:inline-block'>

              <div className='flex flex-row justify-center items-center w-11/12	m-auto'>
                <img src={products.pictureUrl} alt={products.title} className='w-2/5 imgCart h-32'/>
                <p className='p-5 w-2/5'>{products.title}</p>
              </div>
              <div className='flex flex-row justify-center items-center w-4/5 m-auto'>
              <p className='text-center	p-5'>${products.price}</p>
              <p className='text-center	p-5'>Un: {products.quantity}</p>
              <p className='text-center	p-5'>${products.price*products.quantity}</p>
              <button onClick={(e)=>removeItem(products.id)}><MdOutlineDeleteForever className='btnTrash '/></button>
              </div>
          </section>
      )}
      <section className='total flex flex-row justify-center items-center pb-10 sm:flex-col'>
        <h2 className='text-black	'>Total: ${getTotal()}</h2>
        <button className="btn btn-xs sm:w-5/5 md:btn-md lg:btn-lg btnEmpty" onClick={(e)=> clear()}><span>Vaciar carrito</span><MdDeleteOutline className='text-3xl		'/></button>
        
      </section>
    
    
  </div>
  }
  </section>
  )
}
